const getters = {
	web_title: (state) => state.info.web_title,
	yd_product_id: (state) => state.info.yd_product_id,
	captcha_id: (state) => state.info.captcha_id,
	data_uuid: (state) => state.info.data_uuid,
    app_type: (state) => state.info.data_uuid,
};
// this.$store.getters.yd_product_id,
export default getters;
